<template>
  <div class="footBar">
    <p>
      <span>联系地址：上海市宝山区罗泾镇飞腾路168号</span>
      <span>联系电话：13816064096</span>
      <span>邮箱：2875520218@qq.com</span>
    </p>
    <p>
      © 2024 by
      {{ '上海鼎胜机械设备有限公司版权所有' }}
      皖ICP备2024066770号-1
    </p>
  </div>
</template>

<script>
export default {
  name: 'FootBar'
};
</script>

<style scoped lang="less">
* {
  margin: 0;
  padding: 0;
}

.footBar {
  width: 100%;
  height: 110px;
  background-color: #4a4e59;
  padding-top: 24px;
  box-sizing: border-box;
  position: absolute;
  bottom: 0;
  left: 0;

  p {
    margin: 0;
    padding: 0;
    line-height: 36px;
    color: #ffffff;
    font-size: 14px;

    span {
      margin: 0 20px;
    }
  }
}
</style>
